<template>
  <div class="container">
    <!-- NEW COMMENT -->
    <div class="search col-11">
      <b-form-input size="sm" placeholder="Buscar" autocomplete="off" v-model="query">
      </b-form-input>
    </div>
    <div class="row" v-for="(item,index) in filteredItems" v-bind:key="`item.bitacoraId-${index}`">
      <div class="binnacle col-11">
        <div class="wrapper">
          <div class="avatar round"
            v-bind:style="{
              'background-image': 'url('+item.usuarioAvatar+')',
              'background-size': '50px 50px'
            }"
          >
          </div>
          <div class="user-info">
            <div class="name">{{ item.usuarioNombre }}</div>
            <div class="mail">{{ item.usuarioCorreo }}</div>
          </div>
        </div>
        <div class="message">{{ item.mensaje }}</div>
        <div class="date">
          {{ $moment(item.fecha).format('LLLL') }}
        </div>
      </div>
    </div>
    <div v-if="loading">
      <div class="row mt-3">
        <div class="col-1">
          <b-skeleton animation="fade" type="avatar"/>
        </div>
        <div class="col-9">
          <b-skeleton animation="fade" type="input"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ioEDFilesBinnacle } from '@/febos/servicios/api/repositories.api';

export default {
  name: 'BinnacleView',
  data() {
    return {
      query: '',
      items: [],
      loading: false,
    };
  },
  components: {},
  mounted() {
    this.loadBinnacle();
  },
  methods: {
    async loadBinnacle() {
      this.loading = true;
      const response = await ioEDFilesBinnacle({
        fileId: this.getSelectedElement.id,
        folderId: this.getSelectedElement.id
      });
      this.loading = false;
      this.items = response.data.bitacoras;
    },

  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedElement'
    ]),
    currentAvatar() {
      return this.currentUser.avatar || require('../../../../assets/images/no-avatar.svg');
    },
    filteredItems() {
      if (this.query === '') return this.items;
      const that = this;
      return this.items.filter((v) => (
        v.usuarioNombre.toLowerCase().includes(that.query.toLowerCase())
        || v.usuarioCorreo.toLowerCase().includes(that.query.toLowerCase())
        || v.mensaje.toLowerCase().includes(that.query.toLowerCase())
        || v.fecha.toLowerCase().includes(that.query.toLowerCase())
      ));
    }
  },
  watch: {
    getSelectedElement() {
      this.loadBinnacle();
    }
  }
};
</script>
<style lang="css" scoped>
.binnacle {
  margin: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: solid 1px #aaa;

}
.binnacle:hover{
  box-shadow: 0 5px 5px -2px rgb(var(--vs-primary));

}

.name {
  color: black !important;
}

.mail {
  color: black !important;
  font-size: 90%;
  color: #333;
}

.avatar {
  width: 50px;
  height: 50px;
  display: inline-block;
  background-color: transparent !important;
}

.message {
  width: auto;
  display: inline-block;
}

.user-info {
  display: inline-block;
  padding-left: 15px;
  vertical-align: middle;
}

.date {
  position: absolute;
  width: 200px;
  right: 15px;
  top: 10px;
  font-size: 90%;
}
</style>
